(function() {
  'use strict';
  angular.module('eclipseApp.myAccount').config([
    '$stateProvider',
    'dtmServiceConstants',
    'brtProvider',
    function($stateProvider, dtmServiceConstants, brtProvider) {
      $stateProvider
        .state('myAccount', {
          url: '/my-account',
          parent: 'app',
          title: 'myAccount',
          data: {
            authRequired: true,
            showSubHeading: true
          },
          resolve: {
            isLoginProcessCompleted: [
              'authenticationGuardService',
              '$q',
              'commonService',
              '$rootScope',
              function(authenticationGuardService, $q, commonService, $rootScope) {
                return authenticationGuardService.canActivatePromise().then(function(loggedIn) {
                  return loggedIn ? commonService.getAccountDetails($rootScope.userInfo.accounts) : $q.defer().promise;
                });
              }
            ]
          },
          redirectTo: 'myAccount.overview',
          views: {
            content: {
              template: '<div ui-view="content"></div>'
            }
          }
        })
        .state('myAccount.overview', {
          url: '/overview',
          parent: 'myAccount',
          title: 'myAccountOverview',
          params: {
            globalMessage: '',
            accountNumber: '',
            isUsageDeepLink: '',
            isPayInteracResponse: ''
          },
          views: {
            content: {
              templateUrl: 'modules/my-account/overview/overview-redesign.html',
              controller: 'overviewCtrl'
            }
          }
        })
        /* SPRINT 5 - Wireless Register/Manage Credit Card Changes - START */
        .state('myAccount.registerCreditCard', {
          url: '/register-credit-card',
          parent: 'myAccount',
          title: 'myAccountRegisterCreditCard',
          params: {
            accountNumber: ''
          },
          views: {
            content: {
              templateUrl: 'modules/my-account/manage-credit-card/register-credit-card.html',
              controller: 'registerCreditCardCtrl'
            }
          }
        })
        .state('myAccount.registerCreditCardConfirm', {
          url: '/register-credit-card',
          parent: 'myAccount',
          title: 'myAccountRegisterCreditCardConfirm',
          params: {
            accountNumber: ''
          },
          views: {
            content: {
              templateUrl: 'modules/my-account/manage-credit-card/register-credit-card-confirmation.html',
              controller: 'registerCreditCardConfirmCtrl'
            }
          }
        })
        .state('myAccount.manageCreditCard', {
          url: '/manage-credit-card',
          parent: 'myAccount',
          title: 'myAccountManageCreditCard',
          params: {
            accountNumber: ''
          },
          views: {
            content: {
              templateUrl: 'modules/my-account/manage-credit-card/manage-credit-card.html',
              controller: 'manageCreditCardCtrl'
            }
          }
        })
        .state('myAccount.manageCreditCardConfirm', {
          url: '/manage-credit-card',
          parent: 'myAccount',
          title: 'myAccountManageCreditCardConfirm',
          params: {
            accountNumber: ''
          },
          views: {
            content: {
              templateUrl: 'modules/my-account/manage-credit-card/manage-credit-card-confirmation.html',
              controller: 'manageCreditCardConfirmCtrl'
            }
          }
        })
        /* SPRINT 5 - Wireless Register/Manage Credit Card Changes - END */
        /* SPRINT 3,5&6 - Prepaid Dashboard EPIC Changes - START */
        .state('myAccount.prepaidWLDashboard', {
          url: '/prepaidWireless',
          parent: 'myAccount',
          title: 'myAccountPrepaidWirelessDashboard',
          params: {
            accountNumber: '',
            subscriberNo: ''
          },
          views: {
            content: {
              templateUrl: 'modules/my-account/prepaid/dashboard/prepaid-wireless-dashboard.html',
              controller: 'prepaidWLDashboardCtrl'
            }
          }
        })
        .state('myAccount.prepaidRefill', {
          url: '/prepaid-refill',
          parent: 'myAccount',
          title: 'myAccountPrepaidRefill',
          views: {
            content: {
              templateUrl: 'modules/my-account/prepaid/dashboard/refill/prepaid-wireless-refill.html',
              controller: 'prepaidRefillCtrl'
            }
          },
          resolve: {
            retrievePrepaidPlanInfo: [
              'prepaidCommonService',
              'prepaidPlanInfoService',
              'isLoginProcessCompleted',
              function(prepaidCommonService, prepaidPlanInfoService, isLoginProcessCompleted) {
                if (
                  prepaidPlanInfoService.getAirTimePlanSoc() === null ||
                  prepaidPlanInfoService.getAirTimePlanSoc() === ''
                ) {
                  return prepaidCommonService.retrievePrepaidPlanInfo();
                }
              }
            ]
          }
        })
        .state('myAccount.prepaidRefill.autoPayPlan', {
          url: '/prepaid-refill/auto-pay-plan',
          parent: 'myAccount',
          title: 'myAccountPrepaidRefillAutoPayPlan',
          views: {
            content: {
              templateUrl:
                'modules/my-account/prepaid/dashboard/refill/autoPayPlan/prepaid-wireless-refill-autoPayPlan.html',
              controller: 'prepaidRefillAutoPayPlanCtrl'
            }
          },
          resolve: {
            retrievePrepaidPlanInfo: [
              'prepaidCommonService',
              'prepaidPlanInfoService',
              'isLoginProcessCompleted',
              function(prepaidCommonService, prepaidPlanInfoService, isLoginProcessCompleted) {
                if (
                  prepaidPlanInfoService.getAirTimePlanSoc() === null ||
                  prepaidPlanInfoService.getAirTimePlanSoc() === ''
                ) {
                  return prepaidCommonService.retrievePrepaidPlanInfo();
                }
              }
            ],
            retrievePrepaidUserInfo: [
              'prepaidCommonService',
              'prepaidUserInfoService',
              'isLoginProcessCompleted',
              function(prepaidCommonService, prepaidUserInfoService, isLoginProcessCompleted) {
                if (
                  prepaidUserInfoService.getCTN() === null ||
                  prepaidUserInfoService.getCTN() === '' ||
                  prepaidUserInfoService.getBAN() === null ||
                  prepaidUserInfoService.getBAN() === ''
                ) {
                  return prepaidCommonService.retrievePrepaidUserInfo();
                }
              }
            ]
          }
        })
        .state('myAccount.prepaidRefill.autoPayPlan-review', {
          url: '/prepaid-refill/auto-pay-plan',
          parent: 'myAccount',
          title: 'myAccountPrepaidRefillAutoPayPlanReview',
          views: {
            content: {
              templateUrl:
                'modules/my-account/prepaid/dashboard/refill/autoPayPlan/refill-autoPayPlan-review-success.html',
              controller: 'prepaidRefillAutoPayPlanCtrl'
            }
          },
          resolve: {
            retrievePrepaidPlanInfo: [
              'prepaidCommonService',
              'prepaidPlanInfoService',
              'isLoginProcessCompleted',
              function(prepaidCommonService, prepaidPlanInfoService, isLoginProcessCompleted) {
                if (
                  prepaidPlanInfoService.getAirTimePlanSoc() === null ||
                  prepaidPlanInfoService.getAirTimePlanSoc() === ''
                ) {
                  return prepaidCommonService.retrievePrepaidPlanInfo();
                }
              }
            ],
            retrievePrepaidUserInfo: [
              'prepaidCommonService',
              'prepaidUserInfoService',
              'isLoginProcessCompleted',
              function(prepaidCommonService, prepaidUserInfoService, isLoginProcessCompleted) {
                if (
                  prepaidUserInfoService.getCTN() === null ||
                  prepaidUserInfoService.getCTN() === '' ||
                  prepaidUserInfoService.getBAN() === null ||
                  prepaidUserInfoService.getBAN() === ''
                ) {
                  return prepaidCommonService.retrievePrepaidUserInfo();
                }
              }
            ]
          }
        })
        .state('myAccount.prepaidRefill.autoRefillBalance', {
          url: '/prepaid-refill/auto-refill-balance',
          parent: 'myAccount',
          title: 'myAccountPrepaidRefillAutoRefillBalance',
          views: {
            content: {
              templateUrl:
                'modules/my-account/prepaid/dashboard/refill/autoRefillBalance/prepaid-wireless-refill-autoRefillBalance.html',
              controller: 'prepaidRefillAutoBalanceCtrl'
            }
          },
          resolve: {
            retrievePrepaidPlanInfo: [
              'prepaidCommonService',
              'prepaidPlanInfoService',
              'isLoginProcessCompleted',
              function(prepaidCommonService, prepaidPlanInfoService, isLoginProcessCompleted) {
                if (
                  prepaidPlanInfoService.getAirTimePlanSoc() === null ||
                  prepaidPlanInfoService.getAirTimePlanSoc() === ''
                ) {
                  return prepaidCommonService.retrievePrepaidPlanInfo();
                }
              }
            ],
            retrievePrepaidUserInfo: [
              'prepaidCommonService',
              'prepaidUserInfoService',
              'isLoginProcessCompleted',
              function(prepaidCommonService, prepaidUserInfoService, isLoginProcessCompleted) {
                if (
                  prepaidUserInfoService.getCTN() === null ||
                  prepaidUserInfoService.getCTN() === '' ||
                  prepaidUserInfoService.getBAN() === null ||
                  prepaidUserInfoService.getBAN() === ''
                ) {
                  return prepaidCommonService.retrievePrepaidUserInfo();
                }
              }
            ]
          }
        })
        .state('myAccount.prepaidRefill.autoRefillBalance-review', {
          url: '/prepaid-refill/auto-refill-balance',
          parent: 'myAccount',
          title: 'myAccountPrepaidRefillAutoRefillBalanceReview',
          views: {
            content: {
              templateUrl:
                'modules/my-account/prepaid/dashboard/refill/autoRefillBalance/refill-autoRefillBalance-review-success.html',
              controller: 'prepaidRefillAutoBalanceCtrl'
            }
          },
          resolve: {
            retrievePrepaidPlanInfo: [
              'prepaidCommonService',
              'prepaidPlanInfoService',
              'isLoginProcessCompleted',
              function(prepaidCommonService, prepaidPlanInfoService, isLoginProcessCompleted) {
                if (
                  prepaidPlanInfoService.getAirTimePlanSoc() === null ||
                  prepaidPlanInfoService.getAirTimePlanSoc() === ''
                ) {
                  return prepaidCommonService.retrievePrepaidPlanInfo();
                }
              }
            ],
            retrievePrepaidUserInfo: [
              'prepaidCommonService',
              'prepaidUserInfoService',
              function(prepaidCommonService, prepaidUserInfoService) {
                if (
                  prepaidUserInfoService.getCTN() === null ||
                  prepaidUserInfoService.getCTN() === '' ||
                  prepaidUserInfoService.getBAN() === null ||
                  prepaidUserInfoService.getBAN() === ''
                ) {
                  return prepaidCommonService.retrievePrepaidUserInfo();
                }
              }
            ]
          }
        })
        .state('myAccount.prepaidRefill.oneTimeRefill', {
          url: '/prepaid-refill/one-time-refill',
          parent: 'myAccount',
          title: 'myAccountPrepaidRefillOneTimeRefill',
          views: {
            content: {
              templateUrl:
                'modules/my-account/prepaid/dashboard/refill/oneTimeRefill/prepaid-wireless-refill-oneTimeRefill.html',
              controller: 'prepaidRefillOneTimeCtrl'
            }
          },
          resolve: {
            retrievePrepaidPlanInfo: [
              'prepaidCommonService',
              'prepaidPlanInfoService',
              'isLoginProcessCompleted',
              function(prepaidCommonService, prepaidPlanInfoService, isLoginProcessCompleted) {
                if (
                  prepaidPlanInfoService.getAirTimePlanSoc() === null ||
                  prepaidPlanInfoService.getAirTimePlanSoc() === ''
                ) {
                  return prepaidCommonService.retrievePrepaidPlanInfo();
                }
              }
            ],
            retrievePrepaidUserInfo: [
              'prepaidCommonService',
              'prepaidUserInfoService',
              'isLoginProcessCompleted',
              function(prepaidCommonService, prepaidUserInfoService, isLoginProcessCompleted) {
                if (
                  prepaidUserInfoService.getCTN() === null ||
                  prepaidUserInfoService.getCTN() === '' ||
                  prepaidUserInfoService.getBAN() === null ||
                  prepaidUserInfoService.getBAN() === ''
                ) {
                  return prepaidCommonService.retrievePrepaidUserInfo();
                }
              }
            ]
          }
        })
        .state('myAccount.prepaidRefill.oneTimeRefill-review', {
          url: '/prepaid-refill/one-time-refill',
          parent: 'myAccount',
          title: 'myAccountPrepaidRefillOneTimeRefillReview',
          views: {
            content: {
              templateUrl:
                'modules/my-account/prepaid/dashboard/refill/oneTimeRefill/refill-oneTimeRefill-review-success.html',
              controller: 'prepaidRefillOneTimeCtrl'
            }
          },
          resolve: {
            retrievePrepaidPlanInfo: [
              'prepaidCommonService',
              'prepaidPlanInfoService',
              'isLoginProcessCompleted',
              function(prepaidCommonService, prepaidPlanInfoService, isLoginProcessCompleted) {
                if (
                  prepaidPlanInfoService.getAirTimePlanSoc() === null ||
                  prepaidPlanInfoService.getAirTimePlanSoc() === ''
                ) {
                  return prepaidCommonService.retrievePrepaidPlanInfo();
                }
              }
            ],
            retrievePrepaidUserInfo: [
              'prepaidCommonService',
              'prepaidUserInfoService',
              function(prepaidCommonService, prepaidUserInfoService) {
                if (
                  prepaidUserInfoService.getCTN() === null ||
                  prepaidUserInfoService.getCTN() === '' ||
                  prepaidUserInfoService.getBAN() === null ||
                  prepaidUserInfoService.getBAN() === ''
                ) {
                  return prepaidCommonService.retrievePrepaidUserInfo();
                }
              }
            ]
          }
        })
        .state('myAccount.prepaidRefill.oneTimeRefill.interac', {
          url: '/prepaid-refill/one-time-refill/interac',
          parent: 'myAccount',
          title: 'myAccountPrepaidRefillOneTimeRefillInterac',
          views: {
            content: {
              templateUrl:
                'modules/my-account/prepaid/dashboard/refill/oneTimeRefill/refill-interac-review-success.html',
              controller: 'prepaidRefillOneTimeCtrl'
            }
          },
          resolve: {
            retrievePrepaidPlanInfo: [
              'prepaidCommonService',
              'prepaidPlanInfoService',
              'isLoginProcessCompleted',
              function(prepaidCommonService, prepaidPlanInfoService, isLoginProcessCompleted) {
                if (
                  prepaidPlanInfoService.getAirTimePlanSoc() === null ||
                  prepaidPlanInfoService.getAirTimePlanSoc() === ''
                ) {
                  return prepaidCommonService.retrievePrepaidPlanInfo();
                }
              }
            ],
            retrievePrepaidUserInfo: [
              'prepaidCommonService',
              'prepaidUserInfoService',
              'isLoginProcessCompleted',
              function(prepaidCommonService, prepaidUserInfoService, isLoginProcessCompleted) {
                if (
                  prepaidUserInfoService.getCTN() === null ||
                  prepaidUserInfoService.getCTN() === '' ||
                  prepaidUserInfoService.getBAN() === null ||
                  prepaidUserInfoService.getBAN() === ''
                ) {
                  return prepaidCommonService.retrievePrepaidUserInfo();
                }
              }
            ]
          }
        })
        .state('myAccount.prepaidRefill.oneTimeRefill.interac-response', {
          url: '/prepaid-refill/one-time-refill/interac/:response',
          parent: 'myAccount',
          title: 'myAccountPrepaidRefillOneTimeRefillInteracResponse',
          views: {
            content: {
              templateUrl:
                'modules/my-account/prepaid/dashboard/refill/oneTimeRefill/refill-interac-review-success.html',
              controller: 'prepaidRefillOneTimeInteracCtrl'
            }
          },
          resolve: {
            retrievePrepaidPlanInfo: [
              'prepaidCommonService',
              'isLoginProcessCompleted',
              function(prepaidCommonService, isLoginProcessCompleted) {
                return prepaidCommonService.retrievePrepaidPlanInfo();
              }
            ],
            retrievePrepaidUserInfo: [
              'prepaidCommonService',
              'isLoginProcessCompleted',
              function(prepaidCommonService, isLoginProcessCompleted) {
                return prepaidCommonService.retrievePrepaidUserInfo();
              }
            ]
          }
        })
        .state('myAccount.prepaidRefill.redeemVoucher', {
          url: '/prepaid-refill/redeem-voucher',
          parent: 'myAccount',
          title: 'myAccountPrepaidRefillRedeemVoucher',
          views: {
            content: {
              templateUrl:
                'modules/my-account/prepaid/dashboard/refill/redeemVoucher/prepaid-wireless-refill-redeemVoucher.html',
              controller: 'prepaidRefillRedeemVoucherCtrl'
            }
          },
          resolve: {
            retrievePrepaidPlanInfo: [
              'prepaidCommonService',
              'prepaidPlanInfoService',
              'isLoginProcessCompleted',
              function(prepaidCommonService, prepaidPlanInfoService, isLoginProcessCompleted) {
                if (
                  prepaidPlanInfoService.getAirTimePlanSoc() === null ||
                  prepaidPlanInfoService.getAirTimePlanSoc() === ''
                ) {
                  return prepaidCommonService.retrievePrepaidPlanInfo();
                }
              }
            ]
          }
        })
        .state('myAccount.prepaidRefill.redeemVoucher-review', {
          url: '/prepaid-refill/redeem-voucher',
          parent: 'myAccount',
          title: 'myAccountPrepaidRefillRedeemVoucherReview',
          views: {
            content: {
              templateUrl:
                'modules/my-account/prepaid/dashboard/refill/redeemVoucher/redeem-voucher-review-success.html',
              controller: 'prepaidRefillRedeemVoucherCtrl'
            }
          },
          resolve: {
            retrievePrepaidPlanInfo: [
              'prepaidCommonService',
              'prepaidPlanInfoService',
              'isLoginProcessCompleted',
              function(prepaidCommonService, prepaidPlanInfoService, isLoginProcessCompleted) {
                if (
                  prepaidPlanInfoService.getAirTimePlanSoc() === null ||
                  prepaidPlanInfoService.getAirTimePlanSoc() === ''
                ) {
                  return prepaidCommonService.retrievePrepaidPlanInfo();
                }
              }
            ]
          }
        })
        /* SPRINT 3,5&6 Prepaid Dashboard EPIC Changes - END */
        .state('myAccount.billingAndPayments', {
          url: '/billing-payments',
          parent: 'myAccount',
          title: 'myAccountBillingAndPayments',
          views: {
            content: {
              templateUrl: 'modules/my-account/prepaid/billing-payments/prepaidBilling.html',
              controller: 'prepaidBillingCtrl'
            }
          }
        })
        /* SPRINT 8 - ResetVoiceMailPassword - START */
        .state('myAccount.resetVoicemailPassword', {
          url: '/reset-voicemail-password',
          parent: 'myAccount',
          title: 'resetVoicemailPassword',
          params: {
            accountNumber: '',
            subscriberNo: ''
          },
          dtm: {
            transaction: dtmServiceConstants.dtmRules.updateVMPassword.name,
            type: dtmServiceConstants.type.active,
            action: dtmServiceConstants.actions.start
          },
          views: {
            content: {
              templateUrl: 'modules/my-account/reset-voicemail-password/reset-voicemail-password.html',
              controller: 'resetVoicemailPasswordCtrl'
            }
          }
        })
        .state('myAccount.resetVoicemailPasswordConfirmation', {
          url: '/reset-voicemail-password',
          parent: 'myAccount',
          title: 'resetVoicemailPassword',
          params: {
            accountNumber: '',
            subscriberNo: '',
            confirmedPd: ''
          },
          views: {
            content: {
              templateUrl: 'modules/my-account/reset-voicemail-password/reset-voicemail-password-confirmation.html',
              controller: 'resetVoicemailPasswordConfirmCtrl'
            }
          }
        })
        /* SPRINT 8 - ResetVoiceMailPassword - END */
        .state('myAccount.viewProfile', {
          url: '/view-profile',
          parent: 'myAccount',
          title: 'myAccountViewProfile',
          params: {
            accountNumber: '',
            sectionName: '',
            action: ''
          },
          resolve: {
            profileInfo: [
              '$q',
              'ngRouter',
              'isLoginProcessCompleted',
              function($q, ngRouter, isLoginProcessCompleted) {
                // navigate to angular route
                ngRouter.navigate(['/myaccount/view-profile']);
                return $q.defer().promise;
              }
            ]
          }
        })
        .state('myAccount.internet', {
          url: '/internet',
          parent: 'myAccount',
          title: 'myAccountInternet',
          params: {
            accountNumber: '',
            subscriberNo: ''
          },
          views: {
            content: {
              templateUrl: 'modules/my-account/internet/internet-home.html',
              controller: 'internetAccountCtrl'
            }
          },
          resolve: {
            validate: [
              '$q',
              '$stateParams',
              '$rootScope',
              '$state',
              '$timeout',
              function($q, $stateParams, $rootScope, $state, $timeout) {
                var deferred = $q.defer();

                if ($stateParams.accountNumber) {
                  var currentAccount = _.find($rootScope.userInfo.accounts, function(account) {
                    return account.accountNumber === $stateParams.accountNumber;
                  });

                  if (
                    currentAccount &&
                    (currentAccount.status === 'SUSPENDED' || currentAccount.status === 'CANCELLED')
                  ) {
                    deferred.reject(currentAccount.status);
                    $timeout(function() {
                      $state.go('myAccount.overview');
                    });
                  } else {
                    deferred.resolve();
                  }
                } else {
                  deferred.resolve();
                }
                return deferred.promise;
              }
            ],
            accountInfo: [
              'internetSessionService',
              function(internetSessionService) {
                return internetSessionService.setAccountInfo();
              }
            ]
          }
        })
        .state('myAccount.internet.package', {
          url: '/package',
          parent: 'myAccount.internet',
          title: 'myAccountInternetPackage',
          templateUrl: 'modules/my-account/internet/change-internet-package.html',
          // templateProvider: brtProvider.getTemplateProvider('modules/my-account/internet/change-internet-package.html')
          onEnter: ['maintenanceService', function (maintenanceService) {
            maintenanceService.getMaintenance('CPC');

          }]
        })
        .state('myAccount.internet.package.change', {
          url: '/change',
          title: 'myAccountInternetPackageChange',
          views: {
            '@': {
              templateUrl: 'modules/my-account/internet/checkout-change-internet.html',
              controller: 'checkoutChangeInternetCtrl'
            }
          }
        })
        .state('myAccount.internet.package.change.review', {
          url: '/review',
          title: 'myAccountInternetPackageChangeReview',
          templateUrl: 'modules/checkout/views/review.html',
          data: {
            functionality: 'limited',
            showSubHeading: false
          },
          resolve: {
            reviewSummary: [
              'accountDashboardManager',
              'notifier',
              '$rootScope',
              function(accountDashboardManager, notifier, $rootScope) {
                //Modified as part of DSO-16747 - this sets the session info in the session storage on the promotions page and gets deepllinked here.
                var _session =
                  accountDashboardManager.checkoutSession &&
                  accountDashboardManager.checkoutSession.review &&
                  accountDashboardManager.checkoutSession.review.data
                    ? accountDashboardManager.checkoutSession
                    : accountDashboardManager.getSession('checkoutSession');
                if (_session && _session.review.data) {
                  if (_session !== accountDashboardManager.checkoutSession) {
                    angular.copy(_session, accountDashboardManager.checkoutSession);
                  }
                  return _session.review.data;
                } else {
                  _.defer(function() {
                    notifier.notify.error();
                    $rootScope.$apply();
                  });
                }
              }
            ]
          },
          controller: 'changeInternetCtrl'
        })
        .state('myAccount.internet.package.change.confirmation', {
          url: '/confirmation',
          title: 'myAccountInternetPackageChangeConfirmation',
          templateUrl: 'modules/checkout/views/confirmation.html',
          resolve: {
            reviewSummary: [
              'accountDashboardManager',
              'notifier',
              '$rootScope',
              function(accountDashboardManager, notifier, $rootScope) {
                var _session = accountDashboardManager.checkoutSession;
                if (_session && _session.review.data) {
                  return _session.review.data;
                }

                _.defer(function() {
                  notifier.notify.error();
                  $rootScope.$apply();
                });
              }
            ],
            orderConfirmation: [
              'accountDashboardManager',
              'notifier',
              '$rootScope',
              function(accountDashboardManager, notifier, $rootScope) {
                var _session = accountDashboardManager.checkoutSession;
                if (_session && _session.confirmation.data) {
                  return _session.confirmation.data;
                }

                _.defer(function() {
                  notifier.notify.error();
                  $rootScope.$apply();
                });
              }
            ]
          },
          controller: 'checkoutChangeInternetConfirmationCtrl',
          data: {
            showSubHeading: true
          }
        })
        .state('myAccount.internet.changeTechInstall', {
          url: '/changeTechInstall',
          parent: 'myAccount',
          title: 'myAccountInternetTechInstall',
          views: {
            content: {
              templateUrl: 'modules/my-account/internet/change-tech-install.html',
              controller: 'changeTechInstallCtrl'
            }
          }
        })
        // .state('myAccount.tv', {
        //   url: '/tv',
        //   parent: 'myAccount',
        //   title: 'myAccountTV',
        //   params: {
        //     accountNumber: '',
        //     subscriberNo: ''
        //   },
        //   resolve: {
        //     resources: ['$http', 'uteEndpoint', function ($http, uteEndpoint) {
        //       return $http.get('resource/tvPackages.json');
        //     }]
        //   },
        //   views: {
        //     content: {
        //       templateUrl: 'modules/my-account/tv/tv-account.html',
        //       controller: 'tvAccountCtrl'
        //     }
        //   }
        // })
        // .state('myAccount.tv.changePackage', {
        //   url: '/package',
        //   parent: 'myAccount.tv',
        //   title: 'myAccountTVChangePackage',
        //   templateUrl: 'modules/my-account/tv/change-tv-package.html'
        // })
        // .state('myAccount.tv.addChannels', {
        //   url: '/channels',
        //   parent: 'myAccount.tv',
        //   title: 'myAccountTVAddChannels',
        //   templateUrl: 'modules/my-account/tv/add-channels.html'
        // })
        // .state('myAccount.tv.changeThemePacks', {
        //   url: '/theme-packs',
        //   parent: 'myAccount.tv',
        //   title: 'myAccountTVChangeThemePacks',
        //   templateUrl: 'modules/my-account/tv/add-theme-packs.html'
        // })
        .state('myAccount.payNow', {
          url: '/pay-now',
          parent: 'myAccount',
          title: 'myAccountPayNow',
          params: {
            accountNumber: ''
          },
          resolve: {
            validateBRT: [
              '$q',
              '$stateParams',
              '$state',
              '$timeout',
              'isLoginProcessCompleted',
              '$rootScope',
              function($q, $stateParams, $state, $timeout, isLoginProcessCompleted, $rootScope) {
                if (isLoginProcessCompleted) {
                  $timeout(function() {
                    if (angular.isDefined($rootScope.previousState)) {
                      $state.go(
                        'myAccount.payNowEnhancement',
                        { accountNumber: $stateParams.accountNumber },
                        { location: false }
                      );
                    }
                  }, 0);
                }
                return $q.defer().promise;
              }
            ]
          }
        })
        .state('myAccount.payNowEnhancement', {
          url: '/',
          parent: 'myAccount',
          title: 'myAccountPayNow',
          dtm: {
            action: dtmServiceConstants.actions.startEvent,
            trackDataLayer: true,
            trackPageInfo: dtmServiceConstants.dataLayerTrack.page.makeAPayment.start,
            trackSelfServeInfo: dtmServiceConstants.dataLayerTrack.selfServe.makeAPayment,
            addBasicSection: dtmServiceConstants.dataLayerTrack.basicPayloadSections
          },
          params: {
            accountNumber: ''
          }
        })
        .state('myAccount.payNowInteracResponse', {
          url: '/pay-now/interac/:response',
          parent: 'myAccount',
          title: 'myAccountPayNowInteracResponse',
          // views: {
          //   content: {
          //     templateUrl: 'modules/my-account/pay-now/pay-now.html',
          //     controller: 'payNowCtrl'
          //   }
          // },
          resolve: {
            redirect: [
              '$q',
              '$stateParams',
              '$state',
              '$timeout',
              function($q, $stateParams, $state, $timeout) {
                $timeout(function() {
                  $state.go('myAccount.overview', { isPayInteracResponse: $stateParams.response });
                }, 0);
                return $q.defer().promise;
              }
            ]
          }
        })
        .state('myAccount.payNowInteracEnhanceResponse', {
          url: '/',
          parent: 'myAccount',
          title: 'myAccountPayNowInteracResponse',
          params: {
            response: ''
          }
        })
        .state('myAccount.paymentHistory', {
          url: '/payment-history',
          parent: 'myAccount',
          title: 'myAccountPaymentHistory',
          params: {
            accountNumber: ''
          },
          views: {
            content: {
              templateUrl: 'modules/my-account/payment-history/payment-history.html',
              controller: 'paymentHistoryCtrl'
            }
          },
          trackViews: true
        })
        .state('myAccount.paymentMethod', {
          url: '/payment-method',
          parent: 'myAccount',
          title: 'myAccountPaymentMethod',
          params: {
            accountNumber: ''
          },
          resolve: {
            profileInfo: [
              '$q',
              'ngRouter',
              'isLoginProcessCompleted',
              function($q, ngRouter, isLoginProcessCompleted) {
                // navigate to angular route
                ngRouter.navigate(['/myaccount/payment-method']);
                return $q.defer().promise;
              }
            ]
          }
        })
        .state('myAccount.internetUsage', {
          url: '/internet/usage',
          parent: 'myAccount',
          title: 'myAccountInternetUsage',
          params: {
            accountNumber: '',
            subscriberNo: ''
          },
          data: {
            scrollToTop: false
          },
          views: {
            content: {
              templateUrl: 'modules/my-account/internet-usage/internet-usage-home.html',
              controller: 'internetUsageHomeCtrl'
            }
          },
          resolve: {
            accountInfo: [
              'internetSessionService',
              'isLoginProcessCompleted',
              function(internetSessionService, isLoginProcessCompleted) {
                return internetSessionService.setAccountInfo();
              }
            ]
          }
        })
        .state('myAccount.internetUsage.daily', {
          url: '/daily',
          parent: 'myAccount.internetUsage',
          title: 'myAccountInternetUsageDaily',
          //views: {
          //content: {
          templateUrl: 'modules/my-account/internet-usage/internet-usage-daily.html',
          controller: 'internetUsageDailyCtrl',
          resolve: {
            accountInfo: [
              'internetSessionService',
              'isLoginProcessCompleted',
              function(internetSessionService, isLoginProcessCompleted) {
                return internetSessionService.setAccountInfo();
              }
            ]
          }
          //}
          //}
        })
        .state('myAccount.internetUsage.monthly', {
          url: '/monthly',
          parent: 'myAccount.internetUsage',
          title: 'myAccountInternetUsageMonthly',
          //views: {
          //content: {
          templateUrl: 'modules/my-account/internet-usage/internet-usage-monthly.html',
          controller: 'internetUsageMonthlyCtrl',
          resolve: {
            accountInfo: [
              'internetSessionService',
              'isLoginProcessCompleted',
              function(internetSessionService, isLoginProcessCompleted) {
                return internetSessionService.setAccountInfo();
              }
            ]
          }
          //}
          //}
        })
        .state('myAccount.internetUsage.notification', {
          url: '/notification',
          parent: 'myAccount.internetUsage',
          title: 'myAccountInternetUsageNotification',
          //views: {
          //content: {
          templateUrl: 'modules/my-account/internet-usage/internet-usage-notification.html',
          controller: 'internetUsageNotificationCtrl',
          resolve: {
            accountInfo: [
              'internetSessionService',
              'isLoginProcessCompleted',
              function(internetSessionService, isLoginProcessCompleted) {
                return internetSessionService.setAccountInfo();
              }
            ]
          }
          //}
          //}
        })
        .state('myAccount.tvUsage', {
          url: '/tv/usage',
          parent: 'myAccount',
          title: 'myAccountTVUsage',
          views: {
            content: {
              templateUrl: 'modules/my-account/tv-usage/tv-usage-home.html',
              controller: 'tvUsageHomeCtrl'
            }
          }
        })
        .state('myAccount.tvUsage.daily', {
          url: '/daily',
          parent: 'myAccount.tvUsage',
          title: 'myAccountTVUsageDaily',
          views: {
            content: {
              templateUrl: 'modules/my-account/tv-usage/tv-usage-daily.html',
              controller: 'tvUsageDailyCtrl'
            }
          }
        })
        .state('myAccount.tvUsage.monthly', {
          url: '/monthly',
          parent: 'myAccount.tvUsage',
          title: 'myAccountTVUsageMonthly',
          views: {
            content: {
              templateUrl: 'modules/my-account/tv-usage/tv-usage-monthly.html',
              controller: 'tvUsageMonthlyCtrl'
            }
          }
        })
        .state('myAccount.tvUsage.notification', {
          url: '/notification',
          parent: 'myAccount.tvUsage',
          title: 'myAccountTVUsageNotification',
          views: {
            content: {
              templateUrl: 'modules/my-account/tv-usage/tv-usage-notification.html',
              controller: 'tvUsageNotificationCtrl'
            }
          }
        })
        // .state('myAccount.groupID', {
        //   url: '/groupID',
        //   parent: 'myAccount',
        //   title: 'myAccountGroupID',
        //   params: {'globalMessage': ''},
        //   views: {
        //     content: {
        //       templateUrl: 'modules/my-account/group-id/group-id.html',
        //       controller: 'groupIDCtrl'
        //     }
        //   }
        // })
        .state('myAccount.wireless', {
          url: '/wireless',
          parent: 'myAccount',
          title: 'myAccountWireless',
          params: {
            accountNumber: '',
            subscriberNo: '',
            legacy: false
          },
          // views: {
          //   content: {
          //     templateUrl: 'modules/my-account/wireless/wireless-home.html',
          //     controller: 'wirelessHomeCtrl',
          //     controllerAs: 'wdCtrl'
          //   }
          // },
          resolve: {
            // permissions: ['permissionsService', function (permissionsService) {
            //   if (permissionsService.permissionDetail.FIDO_UEP === undefined || permissionsService.permissionDetail.FIDO_UEP === null) {
            //     return permissionsService.getPreferences();
            //   } else {
            //     return true;
            //   }
            // }]
            wirelessInfo: [
              '$q',
              'ngRouter',
              '$stateParams',
              'isLoginProcessCompleted',
              function($q, ngRouter, $stateParams, isLoginProcessCompleted) {
                ngRouter.navigate(['/myaccount/wireless'], {
                  state: {
                    accountNumber: $stateParams.accountNumber,
                    subscriberNo: $stateParams.subscriberNo
                  }
                });
                return $q.defer().promise;
              }
            ]
          }
        })
        .state('myAccount.manageData', {
          url: '/manage-data',
          parent: 'myAccount',
          title: 'myAccountWireless-manageData',
          params: {
            selectedBAN: null,
            selectedCTN: null
          },
          resolve: {
            manageDataInfo: [
              '$q',
              'ngRouter',
              'isLoginProcessCompleted',
              function($q, ngRouter, isLoginProcessCompleted) {
                // navigate to angular route
                ngRouter.navigate(['/myaccount/manage-data']);
                return $q.defer().promise;
              }
            ]
          }
        })
        .state('myAccount.updateSimCard', {
          url: '/update-sim-card',
          parent: 'myAccount',
          title: 'myAccountUpdateSIMCard',
          params: {
            accountNumber: '',
            ctn: ''
          },
          dtm: {
            transaction: dtmServiceConstants.dtmRules.updateSimCard.name,
            type: dtmServiceConstants.type.active,
            action: dtmServiceConstants.actions.startEvent
          },
          views: {
            content: {
              templateUrl: 'modules/my-account/update-sim-card/update-sim-card.html',
              controller: 'updateSimCardCtrl'
            }
          }
        })
        .state('myAccount.updateSimCardReview', {
          url: '/update-sim-card',
          parent: 'myAccount',
          title: 'myAccountUpdateSIMCardReview',
          params: {
            accountNumber: '',
            ctn: '',
            oldSimNumber: '',
            newSimNumber: ''
          },
          views: {
            content: {
              templateUrl: 'modules/my-account/update-sim-card/update-sim-card-review.html',
              controller: 'updateSimCardCtrl'
            }
          }
        })
        // .state('myAccount.redeemFidoDollars', {
        //   url: '/redeemFidoDollars',
        //   parent: 'myAccount',
        //   title: 'myAccountRedeemFidoDollars',
        //   params: {
        //     'accountNumber': ''
        //   },
        //   views: {
        //     content: {
        //       templateUrl: 'modules/my-account/redeem-fido-dollars/redeemFidoDollars.html'
        //     }
        //   }
        // })
        .state('myAccount.retrievePUK', {
          url: '/retrievePUK',
          parent: 'myAccount',
          title: 'myAccountRetrievePUK',
          params: {
            accountNumber: '',
            ctn: ''
          },
          dtm: {
            transaction: dtmServiceConstants.dtmRules.receivePUKCode.name,
            type: dtmServiceConstants.type.active,
            action: dtmServiceConstants.actions.start
          },
          views: {
            content: {
              templateUrl: 'modules/my-account/retrieve-puk/retrievePUK.html',
              controller: 'retrievePUKCtrl'
            }
          }
        })
        .state('myAccount.viewInvoice', {
          url: '/view-invoice-history',
          parent: 'myAccount',
          title: 'myAccountViewInvoice',
          params: {
            accountNumber: '',
            date: ''
          },
          views: {
            content: {
              templateUrl: 'modules/my-account/view-invoice/viewInvoice.html',
              controller: 'viewInvoiceCtrl'
            }
          },
          trackViews: true,
          resolve: {
            validate: [
              '$q',
              '$stateParams',
              '$rootScope',
              '$state',
              '$timeout',
              'brtSwitchCMS',
              'isLoginProcessCompleted',
              function($q, $stateParams, $rootScope, $state, $timeout, brtSwitchCMS, isLoginProcessCompleted) {
                var deferred = $q.defer();
                if (
                  angular.isDefined($rootScope.userInfo.profileType.subscriber) &&
                  $rootScope.userInfo.profileType.subscriber != null &&
                  $rootScope.userInfo.profileType.subscriber != '' &&
                  $rootScope.userInfo.profileType.subscriber &&
                  !brtSwitchCMS.brtSwitch.payNowEnhancementFlow
                ) {
                  $timeout(function() {
                    $state.go('myAccount.payNow');
                  });
                } else {
                  deferred.resolve();
                }
                return deferred.promise;
              }
            ]
          }
        })
        .state('myAccount.viewFidoRewards', {
          url: '/view-fido-rewards',
          parent: 'myAccount',
          title: 'myAccountViewFidoRewards',
          params: {
            accountNumber: '',
            ctn: ''
          },
          views: {
            content: {
              templateUrl: 'modules/my-account/view-fido-rewards/viewFidoRewards.html',
              controller: 'viewFidoRewardsCtrl'
            }
          }
        })
        .state('myAccount.lostStolenSuspendDevice', {
          url: '/lost-stolen-suspend-device',
          parent: 'myAccount',
          title: 'myAccountLostStolenSuspendDevice',
          dtm: {
            transaction: dtmServiceConstants.dtmRules.reportLostDevice.name,
            type: dtmServiceConstants.type.active,
            action: dtmServiceConstants.actions.start
          },
          views: {
            content: {
              templateUrl: 'modules/my-account/lost-stolen-device/lost-stolen-suspend-device.html',
              controller: 'lostStolenSuspendCtrl'
            }
          }
        })
        .state('myAccount.lostStolenSuspendDeviceSuccess', {
          url: '/lost-stolen-suspend-device',
          parent: 'myAccount',
          title: 'myAccountLostStolenSuspendDeviceSuccess',
          views: {
            content: {
              templateUrl: 'modules/my-account/lost-stolen-device/lost-stolen-suspend-device-success.html',
              controller: 'lostStolenSuspendCtrl'
            }
          }
        })
        .state('myAccount.lostStolenReactivateDevice', {
          url: '/lost-stolen-reactivate-device',
          parent: 'myAccount',
          title: 'myAccountLostStolenReactivateDevice',
          views: {
            content: {
              templateUrl: 'modules/my-account/lost-stolen-device/lost-stolen-reactivate-device.html',
              controller: 'lostStolenReactivateCtrl'
            }
          }
        })
        .state('myAccount.lostStolenReactivateDeviceSuccess', {
          url: '/lost-stolen-reactivate-device',
          parent: 'myAccount',
          title: 'myAccountLostStolenReactivateDeviceSuccess',
          views: {
            content: {
              templateUrl: 'modules/my-account/lost-stolen-device/lost-stolen-reactivate-device-success.html',
              controller: 'lostStolenReactivateCtrl'
            }
          }
        })
        .state('myAccount.changePhoneNumber', {
          url: '/change-phone-number',
          parent: 'myAccount',
          title: 'myAccountChangePhoneNumber',
          params: {
            accountNumber: '',
            ctn: ''
          },
          // views: {
          //   content: {
          //     templateUrl: 'modules/my-account/change-phone-number/change-phone-number.html',
          //     controller: 'changePhoneNumberCtrl'
          //   }
          // },
          resolve: {
            redirect: [
              '$q',
              '$stateParams',
              'brtSwitchCMS',
              '$state',
              '$timeout',
              function($q, $stateParams, brtSwitchCMS, $state, $timeout) {
                $timeout(function() {
                  $state.go(
                    'myAccount.changePhoneNumberRedesign',
                    {
                      accountNumber: $stateParams.accountNumber,
                      ctn: $stateParams.ctn
                    },
                    { location: true }
                  );
                }, 0);
                return $q.defer().promise;
              }
            ]
          }
        })
        .state('myAccount.changePhoneNumberRedesign', {
          url: '/change-phone-number',
          parent: 'myAccount',
          title: 'myAccountChangePhoneNumber',
          params: {
            accountNumber: '',
            ctn: ''
          },
          dtm: {
            action: dtmServiceConstants.actions.startEvent,
            trackDataLayer: true,
            trackPageInfo: dtmServiceConstants.dataLayerTrack.page.changeCtn.start,
            trackSelfServeInfo: dtmServiceConstants.dataLayerTrack.selfServe.changeCtn,
            addBasicSection: dtmServiceConstants.dataLayerTrack.basicPayloadSections
          },
          views: {
            content: {
              templateUrl: 'modules/my-account/change-phone-number-redesign/change-phone-number.html',
              controller: 'changePhoneNumberRedesignCtrl'
            }
          }
        })
        // .state('myAccount.changePhoneNumberSelection', {
        //   url: '/change-phone-number',
        //   parent: 'myAccount',
        //   title: 'myAccountChangePhoneNumber',
        //   params: {
        //     accountNumber: '',
        //     ctn: '',
        //     selectedCityCode: '',
        //     selectedProvinceCode: ''
        //   },
        //   views: {
        //     content: {
        //       templateUrl: 'modules/my-account/change-phone-number/change-phone-number-selection.html',
        //       controller: 'changePhoneNumberSelectionCtrl'
        //     }
        //   }
        // })
        .state('myAccount.changePhoneNumberRedesignSelection', {
          url: '/change-phone-number',
          parent: 'myAccount',
          title: 'myAccountChangePhoneNumber',
          params: {
            accountNumber: '',
            ctn: '',
            selectedCityCode: '',
            selectedProvinceCode: ''
          },
          dtm: {
            trackDataLayer: true,
            trackPageInfo: dtmServiceConstants.dataLayerTrack.page.changeCtn.selectNumber,
            addBasicSection: dtmServiceConstants.dataLayerTrack.basicPayloadSections
          },
          views: {
            content: {
              templateUrl: 'modules/my-account/change-phone-number-redesign/change-phone-number-selection.html',
              controller: 'changePhoneNumberRedesignSelectionCtrl'
            }
          }
        })
        // .state('myAccount.changePhoneNumberReview', {
        //   url: '/change-phone-number',
        //   parent: 'myAccount',
        //   title: 'myAccountChangePhoneNumber',
        //   params: {
        //     accountNumber: '',
        //     oldCTN: '',
        //     newCTN: '',
        //     cityCode: ''
        //   },
        //   views: {
        //     content: {
        //       templateUrl: 'modules/my-account/change-phone-number/change-phone-number-review-confirm.html',
        //       controller: 'changePhoneNumberReviewCtrl'
        //     }
        //   }
        // })
        .state('myAccount.changePhoneNumberReviewRedesign', {
          url: '/change-phone-number',
          parent: 'myAccount',
          title: 'myAccountChangePhoneNumber',
          params: {
            accountNumber: '',
            oldCTN: '',
            newCTN: '',
            cityCode: ''
          },
          dtm: {
            trackDataLayer: true,
            trackPageInfo: dtmServiceConstants.dataLayerTrack.page.changeCtn.review,
            addBasicSection: dtmServiceConstants.dataLayerTrack.basicPayloadSections
          },
          views: {
            content: {
              templateUrl: 'modules/my-account/change-phone-number-redesign/change-phone-number-review-confirm.html',
              controller: 'changePhoneNumberRedesignReviewCtrl'
            }
          }
        })
        .state('myAccount.viewTransactionHistory', {
          url: '/view-transaction-history',
          parent: 'myAccount',
          title: 'myAccountViewTransactionHistory',
          params: {
            accountNumber: '',
            ctn: ''
          },
          views: {
            content: {
              templateUrl: 'modules/my-account/view-transaction-history/view-transaction-history-home.html',
              controller: 'transactionHistoryCtrl'
            }
          }
        })
        .state('myAccount.viewTransactionHistory.call', {
          url: '/call',
          parent: 'myAccount.viewTransactionHistory',
          title: 'myAccountViewTransactionHistoryCall',
          params: {
            accountNumber: '',
            ctn: '',
            callTypeParam: ''
          },
          templateUrl: 'modules/my-account/view-transaction-history/call-history.html',
          controller: 'callHistoryCtrl'
        })
        .state('myAccount.viewTransactionHistory.fidoTransaction', {
          url: '/fido-transaction',
          parent: 'myAccount.viewTransactionHistory',
          title: 'myAccountViewTransactionHistoryFidoTransaction',
          params: {
            accountNumber: '',
            ctn: ''
          },
          templateUrl: 'modules/my-account/view-transaction-history/fido-transaction.html',
          controller: 'fidoTransactionCtrl'
        })
        .state('myAccount.viewTransactionHistory.thirdPartyTransaction', {
          url: '/third-party-transaction',
          parent: 'myAccount.viewTransactionHistory',
          title: 'myAccountViewTransactionHistoryThirdPartyTransaction',
          params: {
            accountNumber: '',
            ctn: ''
          },
          templateUrl: 'modules/my-account/view-transaction-history/third-party.html',
          controller: 'thirdPartyCtrl'
        })
        .state('myAccount.liveChat', {
          url: '/live-chat',
          parent: 'myAccount',
          title: 'liveChat',
          params: {
            accountNumber: '',
            subscriberCTN: '',
            source: ''
          },
          views: {
            content: {
              templateUrl: 'modules/live-chat/views/live-chat.html',
              controller: 'liveChatCtrl'
            }
          }
        })
        .state('myAccount.socialMedia', {
          url: '/social-media',
          parent: 'myAccount',
          title: 'socialMedia',
          views: {
            content: {
              templateUrl: 'modules/social-media/views/social-media.html',
              controller: 'socialMediaCtrl'
            }
          }
        })
        .state('myAccount.viewUsage', {
          url: '/view-usage',
          controller: function($scope, $state) {
            $state.go('myAccount.overview', { isUsageDeepLink: 'Y' });
          }
        });
    }
  ]);
})();
